import React, { ReactNode } from 'react';

interface SearchModalProps {
  onClose: () => void;
  children: ReactNode;
}

const SearchModal: React.FC<SearchModalProps> = ({ onClose, children }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative bg-white rounded-lg p-6 w-[90%] max-w-md">
        <button
          className="absolute top-2 right-2 text-gray-700 hover:text-gray-900"
          onClick={onClose}
        >
          <span className="sr-only">Close search</span>
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default SearchModal;
